<template>
  <div class="containerClientMeasurement" >
    <q-card class="grid-table-container drop-shadow">
      <q-card-section  >
        <div class="title-card-client title"><span class="text-h6">{{ $gettext('MEASUREMENTS_INFO') }}</span></div>
        <div class="button-filter" >
          <q-btn color="info"
            icon="filter_list"
            :label="$gettext('FILTER')"
            @click="openSerachModal"
          />
        </div>
        <jt-data-table
          v-if="nmInterface && datatable"
          ref="jtDataTable"
          class="q-px-sm card-crud q-card full-height table-crud drop-shadow"
          :buttons="datatable.buttons"
          :fields="datatable.columns"
          :nm-interface="nmInterface"
          :multiselect="false"
          :extraParams="extraParams"
          :is-paginated="false"
          @action-button="actionButton"
        />
      </q-card-section>
    </q-card>

  <billing-order-send-measurement-report v-if="measurementReportForm" :forms="measurementReportForm" :format="measurementReportFormat" @on-close="onCloseReport"/>

  <q-dialog v-model="showPopUpPDFModal" persistent>
      <q-card>
        <q-card-section class="row justify-center q-mx-lg">
          <span class="text-subtitle1 text-weight-medium text-center">{{$gettext('REPORT_SELECTION')}}</span>
        </q-card-section>
        <q-card-section class="row justify-center q-mx-lg">
          <q-radio v-model="measurementReportFormat" val="pdf" label="PDF" />
          <q-radio v-model="measurementReportFormat" val="xls" label="Excel" />
        </q-card-section>
      <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn :label="$gettext('CANCEL')" color="grey-7" v-close-popup class="q-px-lg" />
          <q-btn :label="$gettext('GENERATE')" color="info" v-close-popup @click="openDialogReport" class="q-px-lg" />
      </q-card-actions>
      </q-card>
  </q-dialog>

  <q-dialog v-model="showCrudSearch" >
    <q-card class="q-card-container-search" >
      <div class="title-card-client search-card-title " style="padding: 10px;"><span class="text-h6">{{ $gettext('FILTER') }}</span></div>
      <div class="detalhe"></div>
      <q-card-section >
        <q-btn
         flat
         round
         dense
         size="18px"
         icon="cancel"
         class="search-modal-close-button"
         @click="() => showCrudSearch = false"
       />
        <crud-form
          class="crud-form-searc"
          ref="crudForm"
          :form="form"
          :model="form.dadosForm"
          @action-click="actionClick"
        >
          <crud-input class="col-6 q-px-sm" nmInput="endServiceDate" />
          <div class="buttons-search">
             <q-btn type="reset"
              color="grey-7"
               @click="clearFilterForm">
             {{ $gettext('CLEAN') }}
             </q-btn>
             <q-btn color="primary"
              @click="refreshGridTable">
               {{ $gettext('SEARCH')}}
             </q-btn>
               </div>
        </crud-form>
      </q-card-section>
    </q-card>
  </q-dialog>

  <modal
      v-if="modalData.show"
      ref="modalMtr"
      :show="modalData.show"
      v-bind="modalData"
      @input="(show) => (modalData.show = show)"
      @action-button="actionButtonUpdate"
    />

  <q-dialog v-model="showDataTableLog">
    <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ $gettext('LOG_MEASUREMENT_SENT') }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
      <q-page-container style="max-height: 85vh;" class="scroll">
        <q-card-section class="q-pb-lg card-table">
          <jt-data-table
            class="table-crud measurementSentTable "
            ref="jtDataTableLog "
            :buttons="dataTableLog.buttons"
            :fields="dataTableLog.columns"
            :nm-interface="nmInterfaceLog"
            :multiselect="false"
            :extraParams="extraParamsLogTable"
            :is-paginated="true"
            @action-button="actionButton"
          />
        </q-card-section>
      </q-page-container>
    </q-layout>
  </q-dialog>
  <JtDocsViewer
      :src="S3PDFData.fileSrc"
      :title="S3PDFData.reportTitle"
      pdf
      ref="reportModal"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtCrud, JtDocs } from 'jtech-webcomps'
import { repository } from 'jtech'
import BillingOrderSendMeasurementReport from '../order/report/BillingOrderSendMeasurementReport.vue'
const { JtDocsViewer } = JtDocs
const { modal, form, input } = JtCrud
@Component({
  mixins: [],
  name: 'ContractClient',
  components: { 'crud-form': form, 'crud-input': input, JtDataTable, modal, BillingOrderSendMeasurementReport, JtDocsViewer },
  props: {
    id: String
  }

})
class ClientMeasurement extends Vue {
  showDataTableLog = false
  extraParams = {}
  nmInterface = 'billingOrder.pesquisarMedicao'
  nmInterfaceLog= 'logMeasurementSent.pesquisar'
  datatable = null
  modalData = {
    show: false,
    detail: false
  }

  showPopUpPDFModal = false
  showCrudSearch = false
  form = {
    show: false
  }

  dataTableLog= {}
  extraParamsLogTable = {}
  measurementReportForm = null
  measurementReportFormat = 'pdf'
  measurementReportParams = null
  S3PDFData = {
    reportTitle: null,
    fileSrc: null
  }

  async mounted () {
    this.extraParams.cliente = this.id
    this.datatable = await repository.resolveDatatable(this.nmInterface, this.extraParams)
  }

  get relFormatoRelatorio () {
    return this.measurementReportFormat === 'pdf' ? 1 : 3
  }

  actionButton (button, params, context) {
    switch (button.action) {
      case 'billingOrder.detalhar':
        this.openDetailModal(button, params)
        break
      case 'billingOrderSendMeasurementReport.billingOrderSendMeasurementReport':
        this.actionButtonReport(params)
        break
      case 'billingOrder.logMeasurement' :
        this.openDataTableLogModal(button, params)
        break
      case 'logMeasurementSent.downloadPDFS3Bucket' :
        this.downloadPDFFromS3Bucket(button, params)
        break
    }
  }

  async downloadPDFFromS3Bucket (button, params) {
    const data = await repository.resolveLogic(button.action, { s3FilePath: params.s3FilePath })
    const Blob = this.transformBase64ToBlob(data.s3FilePath, 'application/pdf', 512)
    this.S3PDFData.fileSrc = URL.createObjectURL(Blob)
    this.S3PDFData.reportTitle = this.getS3PDFName(params)
    this.openPDFFromS3Bucket()
  }

  getS3PDFName (word) {
    return word.s3FilePath.match(/\/([^\\/]+)$/)[1]
  }

  openPDFFromS3Bucket () {
    setTimeout(() => {
      this.$refs.reportModal.show()
    }, 100)
  }

  transformBase64ToBlob (b64Data, contentType, sliceSize) {
    const byteCharacters = atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    return blob
  }

  async openDataTableLogModal (button, params) {
    this.extraParamsLogTable = { id: params.id }
    this.dataTableLog = await repository.resolveDatatable(this.nmInterfaceLog, this.extraParamsLogTable)
    this.showDataTableLog = true
  }

  async refreshGridTable () {
    this.extraParams = { endServiceDate: this.form.dadosForm.endServiceDate, cliente: this.id }
    this.datatable = await repository.resolveDatatable(this.nmInterface, this.extraParams)
    this.$refs.jtDataTable.refresh()
    this.showCrudSearch = false
  }

  actionButtonReport (params) {
    this.showPopUpPDFModal = true
    this.measurementReportParams = { billingOrder: params.id }
  }

  async openDialogReport (button, params) {
    const idParam = { ...this.measurementReportParams, relFormatoRelatorio: this.relFormatoRelatorio }
    const repoForm = await repository.resolve('billingOrderSendMeasurementReport.billingOrderSendMeasurementReport', idParam)
    repoForm[0].dadosForm = { ...repoForm[0].dadosForm, ...idParam }
    this.measurementReportForm = repoForm
  }

  async openSerachModal () {
    const allInterfaceInfos = await repository.resolve(this.nmInterface, {})
    this.form = {
      inputs: allInterfaceInfos[0].inputs,
      dadosForm: { endServiceDate: { initial: null, final: null, inicial: null } },
      nmInterface: allInterfaceInfos[0].nmInterface,
      relacionamentos: allInterfaceInfos[0].relacionamentos
    }
    this.showCrudSearch = true
  }

  async openDetailModal (button, params) {
    const forms = await repository.resolve(button.action, { id: params.id })
    this.modalData = {
      show: true,
      forms: forms,
      label: button.label,
      params: params,
      detail: true
    }
  }

  onCloseReport () {
    this.measurementReportForm = null
  }

  clearFilterForm () {
    this.form.dadosForm.endServiceDate.initial = ''
    this.form.dadosForm.endServiceDate.final = ''
    this.form.dadosForm.endServiceDate.inicial = ''
  }
}
export default ClientMeasurement
</script>

<style scoped >

.drop-shadow{
  box-shadow: none !important;
  padding: 0;

}
.grid-table-container{
  margin-top: -10px;
  padding: 0;
  padding-top: 10px;
}
.containerClientMeasurement{
  position: relative;
}

.title{
  position: relative;
  top: -25px;
  left: -10px;
}
.button-filter{
  position:relative;
  top: -12px;
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}

.buttons-search{
  display: flex;
  justify-content: center;
  gap: 20px;
  position: relative;
  top : 65px
}

.q-card-container-search{
    max-width: 1200px;
    width: 750px;
    height: 330px;
}

.search-card-title{
  font-size: 20px;
  position: relative;
  top: -15px;
  font-weight: 500;
}

.detalhe{
  width: 100%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.3);
  margin: 0;
  padding: 0;
  position: relative;
  bottom: 13px;
  border-radius: 4px;
}

.search-modal-close-button{
  font-size: 20px;
  position: relative;
  bottom: 76px;
  left: 648px;
}

.crud-form-searc{
  position: relative;
  bottom: 15px;
}

.measurementSentTable{
  border-radius: 4px;
}

</style>
